import type { Component } from "solid-js";
import { registerPanel } from "@/panel-registry";
import { NetworkView } from "./network";
import type { OnPanelAction } from "@/shared/plugin-panel-host";
import { setPendingRdpTarget, setPendingWebTarget, activatePanel } from "@/shared/network-actions";

const onAction: OnPanelAction = (type, payload) => {
  if (type === "rdp") {
    setPendingRdpTarget({ host: payload.host, port: payload.port });
    activatePanel("panel:rdp");
  } else if (type === "web") {
    setPendingWebTarget({
      host: payload.host,
      port: payload.port,
      url: payload.url || `http://${payload.host}${payload.port && payload.port !== 80 ? ":" + payload.port : ""}`,
    });
    activatePanel("panel:lanbrowser");
  } else if (type === "smb") {
    activatePanel("panel:smb");
  } else if (type === "files") {
    activatePanel("panel:files");
  } else if (type === "ssh") {
    activatePanel("panel:ssh");
  }
};

const NetworkLanPanel: Component = () => <NetworkView title="Découverte LAN" view="lan" onAction={onAction} />;

registerPanel("network-lan", NetworkLanPanel);
export default NetworkLanPanel;
